import React from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@ui/index';
import type { DialogProps } from '@ui/index';

export interface ErrorDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  primaryActionText?: string;
  secondaryActionText?: string;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  dialogProps?: Partial<DialogProps>;
}

export default function ErrorDialog({
  open,
  title = 'Something went wrong',
  message,
  onClose,
  primaryActionText = 'OK',
  secondaryActionText,
  onPrimaryAction,
  onSecondaryAction,
  dialogProps
}: ErrorDialogProps): JSX.Element {
  return (
    <Dialog data-testid="ui-custom-error-dialog-modal-action" open={open} onClose={onClose} {...dialogProps}>
      {title && (
        <DialogTitle data-testid="ui-custom-error-dialog-header-action" sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      )}
      <DialogContent>
        <Box data-testid="ui-custom-error-dialog-container-action">
          <Typography data-testid="ui-custom-error-dialog-text-action" variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
            {message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        {secondaryActionText && (
          <Button data-testid="ui-custom-error-dialog-btn-action-1" variant="text" color="inherit" onClick={onSecondaryAction || onClose}>
            {secondaryActionText}
          </Button>
        )}
        <Button data-testid="ui-custom-error-dialog-btn-action-2" variant="contained" color="error" onClick={onPrimaryAction || onClose}>
          {primaryActionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}


